
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section 
      className="py-20 bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(rgba(16, 185, 129, 0.9), rgba(16, 185, 129, 0.9)), url('https://public.readdy.ai/ai/img_res/ca82a10147d8c4bcec5be27e4e89e1b9.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h2 className="text-4xl md:text-6xl font-bold mb-6">
          Ready for an Unforgettable
          <span className="block">Culinary Experience?</span>
        </h2>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
          Join thousands of satisfied clients who have discovered the magic of private chef dining. 
          Your perfect culinary experience is just a click away.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/chefs">
            <Button size="lg" className="w-full sm:w-auto bg-white text-emerald-600 hover:bg-gray-100">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-search-line"></i>
              </div>
              Find Your Chef Now
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-emerald-600">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-phone-line"></i>
              </div>
              Get Consultation
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
